export interface ExcelColumnConfig {
  wch?: number; // character width
}

export interface ExcelExportOptions {
  filename: string;
  sheetName?: string;
  headers: string[];
  rows: (string | number | boolean | null | undefined)[][];
  columnWidths?: ExcelColumnConfig[];
}

/**
 * Dynamically loads SheetJS (xlsx) and exports data to an Excel file (.xlsx).
 * Dynamic import ensures that xlsx is loaded on-demand, keeping the initial bundle light.
 */
export const exportToExcel = async (options: ExcelExportOptions): Promise<void> => {
  const XLSX = await import("xlsx");
  const worksheetData = [options.headers, ...options.rows];
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

  // Auto-calculate or set column widths
  if (options.columnWidths && options.columnWidths.length > 0) {
    worksheet["!cols"] = options.columnWidths;
  } else {
    // Basic auto-fit column width calculation
    const colWidths = options.headers.map((header, colIdx) => {
      let maxLen = header ? String(header).length : 10;
      for (const row of options.rows) {
        const val = row[colIdx];
        if (val !== undefined && val !== null) {
          const len = String(val).length;
          if (len > maxLen) {
            maxLen = len;
          }
        }
      }
      return { wch: Math.min(Math.max(maxLen + 3, 12), 50) };
    });
    worksheet["!cols"] = colWidths;
  }

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, options.sheetName || "Sheet1");
  XLSX.writeFile(workbook, `${options.filename}.xlsx`);
};

